import { render, staticRenderFns } from "./StarterPackLoader.vue?vue&type=template&id=6346c440&scoped=true"
import script from "./StarterPackLoader.vue?vue&type=script&lang=js"
export * from "./StarterPackLoader.vue?vue&type=script&lang=js"
import style0 from "./StarterPackLoader.vue?vue&type=style&index=0&id=6346c440&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6346c440",
  null
  
)

export default component.exports